import React from "react";
import RouterWhitHeader from "./view/main/RouterWithHeader";


function App() {
  return (
    <>
        <RouterWhitHeader/>
    </>
  );
}

export default App;
